import { useSEO } from "../hooks/useSEO";
import { useState } from "react";
import { GOLD, NAVY, WHITE, CREAM, CONTACT, CORAL, TEAL, ALTIN_KOYU, DISPLAY, GOVDE, ALTIN_PARLAK, BLOK } from "../data/constants";
import { useMobile } from "../hooks/useMobile";

// ─── HERO ─────────────────────────────────────────────────────────────────────
function ContactHero() {
  const isMobile = useMobile();
  return (
    <section style={{ background: BLOK, paddingTop: isMobile ? 110 : 140, paddingBottom: isMobile ? 64 : 100, padding: isMobile ? "110px 6% 64px" : "140px 5% 100px", position: "relative", overflow: "hidden", boxSizing: "border-box" }}>
      <div style={{ position: "absolute", right: "-8%", top: "-10%", width: 500, height: 500, borderRadius: "50%", border: "1px solid rgba(168,121,42,0.1)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", right: "-2%", top: "10%", width: 300, height: 300, borderRadius: "50%", border: "1px solid rgba(168,121,42,0.07)", pointerEvents: "none" }} />
      <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 2 }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(168,121,42,0.12)", border: "1px solid rgba(168,121,42,0.3)", borderRadius: 4, padding: "6px 14px", marginBottom: 24 }}>
          <span style={{ width: 6, height: 6, borderRadius: "50%", background: GOLD, display: "inline-block" }} />
          <span style={{ color: ALTIN_PARLAK, fontFamily: GOVDE, fontSize: 10, fontWeight: 700, letterSpacing: 2 }}>İLETİŞİM</span>
        </div>
        <h1 style={{ fontFamily: DISPLAY, fontSize: isMobile ? "clamp(32px, 9vw, 52px)" : "clamp(40px, 5.5vw, 68px)", color: WHITE, fontWeight: 700, lineHeight: 1.1, margin: "0 0 10px" }}>
          <span style={{ color: ALTIN_PARLAK }}>Konuşmaya</span>
        </h1>
        <h1 style={{ fontFamily: DISPLAY, fontSize: isMobile ? "clamp(32px, 9vw, 52px)" : "clamp(40px, 5.5vw, 68px)", fontWeight: 700, lineHeight: 1.1, margin: "0 0 24px", color: ALTIN_PARLAK }}>
          Hazır Mısın?
        </h1>
        <p style={{ fontFamily: GOVDE, fontSize: isMobile ? 14 : 17, color: "rgba(255,255,255,0.6)", lineHeight: 1.8, maxWidth: 500, margin: 0 }}>
          İlk görüşme ücretsiz ve bağlayıcı değil. Markanı, hedeflerini ve bütçeni konuşalım.
        </p>
      </div>
      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}>
        <svg viewBox="0 0 1440 50" fill="none" style={{ display: "block", width: "100%" }}>
          <path d="M0 50 L0 25 Q360 0 720 25 Q1080 50 1440 25 L1440 50 Z" fill={CREAM} />
        </svg>
      </div>
    </section>
  );
}

// ─── FORM + BİLGİLER ──────────────────────────────────────────────────────────
function ContactMain() {
  const isMobile = useMobile();
  const [form, setForm] = useState({ name: "", company: "", phone: "", website: "", message: "" });
  const [focused, setFocused] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch("/api/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.success) {
        setSubmitted(true);
      } else {
        setError(data.message || "Bir hata oluştu. Lütfen tekrar deneyin.");
      }
    } catch (err) {
      setError("Bağlantı hatası. Lütfen internet bağlantınızı kontrol edin.");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = (name) => ({
    width: "100%", boxSizing: "border-box",
    background: WHITE,
    border: `1.5px solid ${focused === name ? GOLD : "rgba(18,18,15,0.12)"}`,
    borderRadius: 10, padding: "14px 16px",
    fontFamily: GOVDE, fontSize: 14, color: NAVY,
    outline: "none", transition: "border-color 0.2s",
  });

  const labelStyle = {
    fontFamily: GOVDE, fontSize: 12, fontWeight: 600,
    color: "#3E3E38", letterSpacing: 0.3, marginBottom: 6, display: "block",
  };

  const contactItems = [
    { icon: "", label: "Telefon", value: CONTACT.phone, href: `tel:${CONTACT.phone}` },
    { icon: "✉", label: "E-posta", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: "", label: "Adres", value: CONTACT.address, href: null },
    { icon: "", label: "WhatsApp", value: "Hızlı mesaj için", href: "https://wa.me/908502428674" },
  ];

  return (
    <section style={{ background: CREAM, padding: isMobile ? "64px 6%" : "80px 5%", boxSizing: "border-box" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1.6fr 1fr", gap: isMobile ? 48 : 64, alignItems: "start" }}>

        {/* FORM */}
        <div style={{ background: WHITE, borderRadius: 20, padding: isMobile ? "32px 24px" : "48px 44px", boxShadow: "0 4px 32px rgba(18,18,15,0.07)" }}>
          {!submitted ? (
            <>
              <div style={{ marginBottom: 32 }}>
                <h2 style={{ fontFamily: DISPLAY, fontSize: isMobile ? 24 : 28, color: NAVY, fontWeight: 700, margin: "0 0 8px" }}>
                  Ücretsiz <span style={{ color: TEAL }}>Analiz</span> Talep Et
                </h2>
                <p style={{ fontFamily: GOVDE, fontSize: 14, color: "#3E3E38", margin: 0, lineHeight: 1.7 }}>
                  Formu doldur, en geç 24 saat içinde sana ulaşalım.
                </p>
              </div>

              <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                {/* Ad Soyad + Firma */}
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 16 }}>
                  <div>
                    <label style={labelStyle}>Ad Soyad *</label>
                    <input
                      name="name" value={form.name} onChange={handleChange}
                      onFocus={() => setFocused("name")} onBlur={() => setFocused(null)}
                      placeholder="Adın Soyadın" required
                      style={inputStyle("name")}
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>Firma Adı *</label>
                    <input
                      name="company" value={form.company} onChange={handleChange}
                      onFocus={() => setFocused("company")} onBlur={() => setFocused(null)}
                      placeholder="Firma adın" required
                      style={inputStyle("company")}
                    />
                  </div>
                </div>

                {/* Telefon + Website */}
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 16 }}>
                  <div>
                    <label style={labelStyle}>Telefon *</label>
                    <input
                      name="phone" value={form.phone} onChange={handleChange}
                      onFocus={() => setFocused("phone")} onBlur={() => setFocused(null)}
                      placeholder="+90 850 242 8674" required
                      style={inputStyle("phone")}
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>İnternet Sitesi <span style={{ fontWeight: 400, color: "#71716A" }}>(varsa)</span></label>
                    <input
                      name="website" value={form.website} onChange={handleChange}
                      onFocus={() => setFocused("website")} onBlur={() => setFocused(null)}
                      placeholder="www.firmaniz.com"
                      style={inputStyle("website")}
                    />
                  </div>
                </div>

                {/* Mesaj */}
                <div>
                  <label style={labelStyle}>Mesaj / Notlar</label>
                  <textarea
                    name="message" value={form.message} onChange={handleChange}
                    onFocus={() => setFocused("message")} onBlur={() => setFocused(null)}
                    placeholder="Markan, hedeflerin veya sormak istediklerin hakkında kısaca bilgi verebilirsin..."
                    rows={4}
                    style={{ ...inputStyle("message"), resize: "vertical", minHeight: 120 }}
                  />
                </div>

                {/* Hata mesajı */}
                {error && (
                  <div style={{ background: "#FBF1F2", border: "1px solid #F5DFE2", borderRadius: 10, padding: "12px 16px", fontFamily: GOVDE, fontSize: 13, color: "#A33241", lineHeight: 1.6 }}>
                     {error}
                  </div>
                )}

                {/* Gönder */}
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    background: loading ? "rgba(168,121,42,0.7)" : GOLD,
                    color: NAVY, border: "none", borderRadius: 10,
                    padding: "16px 32px", fontFamily: GOVDE,
                    fontSize: 15, fontWeight: 700, letterSpacing: 0.5,
                    cursor: loading ? "not-allowed" : "pointer",
                    transition: "all 0.25s", width: "100%",
                    display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                  }}
                >
                  {loading ? (
                    <>
                      <span style={{ width: 16, height: 16, border: `2px solid ${NAVY}`, borderTopColor: "transparent", borderRadius: "50%", display: "inline-block", animation: "spin 0.8s linear infinite" }} />
                      Gönderiliyor...
                    </>
                  ) : "Analiz Talep Et →"}
                </button>

                <p style={{ fontFamily: GOVDE, fontSize: 12, color: "#71716A", textAlign: "center", margin: 0 }}>
                  Bilgilerin üçüncü kişilerle paylaşılmaz. En geç 24 saat içinde dönüş yapılır.
                </p>
              </form>

              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </>
          ) : (
            /* Teşekkür mesajı */
            <div style={{ textAlign: "center", padding: isMobile ? "32px 8px" : "48px 24px" }}>
              <div style={{ width: 72, height: 72, background: `rgba(168,121,42,0.12)`, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 24px", fontSize: 32 }}>
                
              </div>
              <h3 style={{ fontFamily: DISPLAY, fontSize: isMobile ? 22 : 26, color: NAVY, fontWeight: 700, margin: "0 0 12px" }}>
                Mesajınız Alındı!
              </h3>
              <p style={{ fontFamily: GOVDE, fontSize: 15, color: "#3E3E38", lineHeight: 1.8, margin: "0 0 8px" }}>
                Teşekkürler, <strong style={{ color: NAVY }}>{form.name}</strong>. En geç <strong style={{ color: NAVY }}>24 saat</strong> içinde seninle iletişime geçeceğiz.
              </p>
              <p style={{ fontFamily: GOVDE, fontSize: 14, color: "#71716A", margin: "0 0 32px" }}>
                Acil bir ihtiyacın varsa bizi direkt arayabilirsin.
              </p>
              <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
                <a href={`tel:${CONTACT.phone}`} style={{ background: BLOK, color: ALTIN_PARLAK, padding: "12px 24px", borderRadius: 8, fontFamily: GOVDE, fontSize: 14, fontWeight: 700, textDecoration: "none" }}>
                   Hemen Ara
                </a>
                <button onClick={() => { setSubmitted(false); setForm({ name: "", company: "", phone: "", website: "", message: "" }); }}
                  style={{ background: "transparent", color: NAVY, padding: "12px 24px", borderRadius: 8, border: "1px solid rgba(18,18,15,0.15)", fontFamily: GOVDE, fontSize: 14, cursor: "pointer" }}>
                  Yeni Mesaj
                </button>
              </div>
            </div>
          )}
        </div>

        {/* BİLGİLER + HIZLI ERİŞİM */}
        <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
          {/* İletişim bilgileri */}
          <div style={{ background: BLOK, borderRadius: 20, padding: isMobile ? "28px 24px" : "36px 32px", overflow: "hidden", position: "relative" }}>
            <div style={{ position: "absolute", right: -40, bottom: -40, width: 180, height: 180, borderRadius: "50%", border: "1px solid rgba(168,121,42,0.1)", pointerEvents: "none" }} />
            <h3 style={{ fontFamily: DISPLAY, fontSize: 18, color: WHITE, fontWeight: 700, margin: "0 0 24px" }}>İletişim Bilgileri</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
              {contactItems.map(({ icon, label, value, href }, i) => (
                <div key={i} style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                  <div style={{ width: 38, height: 38, background: "rgba(168,121,42,0.1)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 16 }}>{icon}</div>
                  <div>
                    <div style={{ fontFamily: GOVDE, fontSize: 10, fontWeight: 700, color: "rgba(255,255,255,0.35)", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 3 }}>{label}</div>
                    {href ? (
                      <a href={href} style={{ fontFamily: GOVDE, fontSize: 14, color: WHITE, textDecoration: "none", fontWeight: 500 }}>{value}</a>
                    ) : (
                      <span style={{ fontFamily: GOVDE, fontSize: 14, color: WHITE, fontWeight: 500 }}>{value}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Çalışma saatleri */}
          <div style={{ background: WHITE, borderRadius: 20, padding: isMobile ? "24px 22px" : "32px 28px", border: "1px solid rgba(18,18,15,0.07)" }}>
            <h3 style={{ fontFamily: DISPLAY, fontSize: 16, color: NAVY, fontWeight: 700, margin: "0 0 18px" }}>Çalışma Saatleri</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                { gun: "Pazartesi – Cuma", saat: "09:00 – 18:00" },
                { gun: "Cumartesi", saat: "10:00 – 14:00" },
                { gun: "Pazar", saat: "Kapalı" },
              ].map(({ gun, saat }, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: i < 2 ? "1px solid rgba(18,18,15,0.05)" : "none" }}>
                  <span style={{ fontFamily: GOVDE, fontSize: 13, color: "#3E3E38" }}>{gun}</span>
                  <span style={{ fontFamily: GOVDE, fontSize: 13, fontWeight: 700, color: saat === "Kapalı" ? "#71716A" : NAVY }}>{saat}</span>
                </div>
              ))}
            </div>
          </div>

          {/* WhatsApp hızlı erişim */}
          <a
            href="https://wa.me/908502428674"
            target="_blank"
            rel="noreferrer"
            style={{
              background: "#25D366", borderRadius: 20,
              padding: "22px 24px", textDecoration: "none",
              display: "flex", alignItems: "center", gap: 14,
            }}
          >
            <div style={{ fontSize: 28, flexShrink: 0 }}></div>
            <div>
              <div style={{ fontFamily: DISPLAY, fontSize: 15, fontWeight: 700, color: WHITE, marginBottom: 3 }}>WhatsApp ile Yaz</div>
              <div style={{ fontFamily: GOVDE, fontSize: 12, color: "rgba(255,255,255,0.8)" }}>Hızlı soruların için anında yanıt</div>
            </div>
            <div style={{ marginLeft: "auto", color: WHITE, fontSize: 18 }}>›</div>
          </a>
        </div>
      </div>
    </section>
  );
}

// ─── SSS ──────────────────────────────────────────────────────────────────────
function FAQ() {
  const isMobile = useMobile();
  const [open, setOpen] = useState(null);
  const faqs = [
    { q: "İlk görüşme ücretli mi?", a: "Hayır. İlk analiz görüşmesi tamamen ücretsiz ve bağlayıcı değil. Markanı tanımak ve sana en uygun yaklaşımı belirlemek için bu görüşmeyi yapıyoruz." },
    { q: "Minimum bütçe gereksinimi var mı?", a: "Sabit bir minimum rakam vermiyoruz. Her firma ve ihtiyaç farklı. Bütçeni ve hedeflerini paylaşman durumunda sana en verimli planı sunuyoruz." },
    { q: "Kaç günde sonuç alınır?", a: "Bu büyük ölçüde hizmet türüne bağlı. Dijital reklamlarda ilk veriler 7-14 günde gelir; SEO ve marka çalışmaları daha uzun vadeli süreçlerdir. Tüm bunları görüşmede detaylıca aktarıyoruz." },
    { q: "Sadece İstanbul'daki firmalara mı hizmet veriyorsunuz?", a: "Hayır. Türkiye genelinde ve yurt dışında da hizmet veriyoruz. Görüşmeler online veya yüz yüze yapılabilir." },
    { q: "Sözleşme süresi ne kadar?", a: "Hizmet türüne göre değişir. Kampanya bazlı çalışmalar için uzun dönem sözleşme zorunluluğu yok. Detayları görüşmede konuşuyoruz." },
  ];

  return (
    <section style={{ background: WHITE, padding: isMobile ? "64px 6%" : "80px 5%", boxSizing: "border-box" }}>
      <div style={{ maxWidth: 800, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: isMobile ? 36 : 52 }}>
          <div style={{ display: "inline-block", background: "rgba(168,121,42,0.1)", border: "1px solid rgba(168,121,42,0.25)", borderRadius: 4, padding: "5px 12px", marginBottom: 16 }}>
            <span style={{ color: ALTIN_KOYU, fontSize: 11, fontWeight: 700, letterSpacing: 2, fontFamily: GOVDE }}>SIKÇA SORULANLAR</span>
          </div>
          <h2 style={{ fontFamily: DISPLAY, fontSize: isMobile ? "clamp(24px, 7vw, 34px)" : "clamp(26px, 3vw, 38px)", color: NAVY, fontWeight: 700, margin: 0 }}>
            <span style={{ color: TEAL }}>Aklındaki</span> <span style={{ color: ALTIN_KOYU }}>Sorular</span>
          </h2>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {faqs.map((faq, i) => (
            <div key={i}
              style={{ background: open === i ? NAVY : WHITE, borderRadius: 12, border: `1px solid ${open === i ? NAVY : "rgba(18,18,15,0.08)"}`, overflow: "hidden", transition: "all 0.3s ease" }}>
              <button
                onClick={() => setOpen(open === i ? null : i)}
                style={{ width: "100%", background: "none", border: "none", padding: "20px 24px", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", gap: 16, textAlign: "left" }}>
                <span style={{ fontFamily: DISPLAY, fontSize: isMobile ? 15 : 16, fontWeight: 700, color: open === i ? WHITE : NAVY, lineHeight: 1.4 }}>{faq.q}</span>
                <span style={{ fontSize: 20, color: ALTIN_KOYU, flexShrink: 0, transform: open === i ? "rotate(45deg)" : "none", transition: "transform 0.3s", lineHeight: 1 }}>+</span>
              </button>
              <div style={{ maxHeight: open === i ? "300px" : "0", overflow: "hidden", transition: "max-height 0.35s ease" }}>
                <p style={{ fontFamily: GOVDE, fontSize: 14, color: open === i ? "rgba(255,255,255,0.7)" : "#3E3E38", lineHeight: 1.8, margin: 0, padding: "0 24px 22px" }}>{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── EXPORT ───────────────────────────────────────────────────────────────────
export default function ContactPage() {
  useSEO({ title: "İletişim: Ücretsiz Analiz Görüşmesi", description: "Whayns Dijital ile iletişime geçin. Ücretsiz analiz görüşmesi için formu doldurun veya bizi arayın. +90 850 242 8674", path: "/iletisim" });
  return (
    <div style={{ overflowX: "hidden", width: "100%" }}>
      <ContactHero />
      <ContactMain />
      <FAQ />
    </div>
  );
}